// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"MoreSpaces_Wrapper__3Q1uR"};